import { axiosInstanceWithToken } from 'utils/axios';
import { IProductResource } from '../../server/types';

export const deleteProduct = async (id: string) => axiosInstanceWithToken().delete<IProductResource>(`/products/${id}`);

export const createProduct = async (data: Partial<IProductResource>) =>
  axiosInstanceWithToken().post<IProductResource>(`/products`, data);

export const updateProduct = async (id: string, data: Partial<IProductResource>) =>
  axiosInstanceWithToken().patch<IProductResource>(`/products/${id}`, data);

export const fetchProducts = async () => axiosInstanceWithToken().get<{ products: IProductResource[] }>(`/products`);

export const fetchProduct = async (id: string) => axiosInstanceWithToken().get<IProductResource>(`/products/${id}`);
